/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Paste_Text_SubtitleInputs */

const en_mobile_paste_text_subtitle = /** @type {(inputs: Mobile_Paste_Text_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn pasted text into audio`)
};

const es_mobile_paste_text_subtitle = /** @type {(inputs: Mobile_Paste_Text_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte texto pegado en audio`)
};

/**
* | output |
* | --- |
* | "Turn pasted text into audio" |
*
* @param {Mobile_Paste_Text_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_paste_text_subtitle = /** @type {((inputs?: Mobile_Paste_Text_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Paste_Text_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_paste_text_subtitle(inputs)
	return en_mobile_paste_text_subtitle(inputs)
});